import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import { LoadingButton, TextField, EmailVerification } from '../common';
import { useLogin } from './hooks';
import { SeelEmail } from '../note';
import { ErrorBar } from '../error-bar';
import classes from './login-form.module.css';

export const EmailContact = () => {
  const { t } = useTranslation();
  const Tip = t('Need help? Contact us at');
  return (
    <section className={classes.tip}>
      <span>{Tip}</span>
      <SeelEmail style={{ fontSize: '14px', lineHeight: '20px' }} />
    </section>
  );
};

export const LoginForm = () => {
  const { t } = useTranslation();
  const {
    email,
    orderId,
    isBtnDisable,
    emailHelperText,
    emailLabelText,
    orderLabelText,
    orderIdHelperText,
    isEmailValid,
    isOrderIdValid,
    isLoading,
    isInvalidBarShow,
    onClickBtn,
    onChangeEmail,
    onChangeOrderId,
    loginVerifyEmail,
  } = useLogin();

  const [loginAccessStatus, setLoginAccessStatus] = useState();
  const [loginEmailSend, setLoginEmailSend] = useState(false);
  const [showVerify, setShowVerify] = useState(false);

  const InvalidError = t('Invalid email address or order.');
  const Title = t('To begin, please provide us with your order details');
  const handleResend = async () => {
    // 调用重发邮件(的后端接口或逻辑
    const result = await loginVerifyEmail?.({ accessToken: isInvalidBarShow?.accessToken, rcVersion: 2, redirectUrl: window?.location?.href });

    setLoginEmailSend(result);
    console.log('Resending email...');
    return result;
  };

  useEffect(() => {
    if ([200052, 200053].includes(isInvalidBarShow?.status)) {
      setShowVerify(true);
      setLoginEmailSend(isInvalidBarShow.result);
      setLoginAccessStatus(isInvalidBarShow?.status);
    }
  }, [isInvalidBarShow]);

  // console.log('isInvalidBarShow', isInvalidBarShow);
  return (
    <div>
      {!showVerify && (<section className={classes.title}>{Title}</section>)}
      <Box
        component="form"
        noValidate
        autoComplete="off"
      >
        {isInvalidBarShow.show && (
          <ErrorBar
            message={t(isInvalidBarShow.message) || isInvalidBarShow.message || InvalidError}
            canClose={false}
            className={classes.error}
          />
        )}
        {!showVerify && (
          <>
            <section className={classes.input_block}>
              <TextField
                id="login-email-input"
                label={emailLabelText}
                placeholder={emailLabelText}
                variant="outlined"
                color="input"
                error={!isEmailValid}
                defaultValue={email}
                helperText={emailHelperText}
                onChange={onChangeEmail}
              />
            </section>
            <section className={classes.input_block_second}>
              <TextField
                id="login-order-id-input"
                label={orderLabelText}
                placeholder={orderLabelText}
                variant="outlined"
                color="input"
                error={!isOrderIdValid}
                defaultValue={orderId}
                helperText={orderIdHelperText}
                onChange={onChangeOrderId}
              />
            </section>
            <LoadingButton
              disabled={isBtnDisable}
              loading={isLoading}
              classes={{
                root: classes.login_btn,
                disabled: classes.disable_btn,
              }}
              onClick={onClickBtn}
              id="login_next"
            >
              {isLoading ? '' : t('Next')}
            </LoadingButton>
          </>
        )}

      </Box>
      {!showVerify && (<EmailContact />)}
      {
        showVerify && isInvalidBarShow?.accessToken && (
          <EmailVerification
            email={email}
            isOpen={showVerify}
            loginEmailSend={loginEmailSend}
            loginAccessStatus={loginAccessStatus}
            loginAccessToken={isInvalidBarShow?.accessToken}
            onClose={() => setShowVerify(false)}
            onResend={handleResend}
          />
        )
      }
    </div>
  );
};
